import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ selectedArticleType: string }>;

export const DispatchSetSelectedArticleType: HandlerType = props => {
    props.dispatch({
        type: "Custom/Article/SetSelectedArticleType",
        selectedArticleType: props.parameter.selectedArticleType,
    });
};

export const chain = [DispatchSetSelectedArticleType];

const cenSetSelectedArticleType = createHandlerChainRunner(chain, "cenSetSelectedArticleType");
export default cenSetSelectedArticleType;
